import React from 'react';
import { useIntl } from 'react-intl';

import Box from 'carbon-react/lib/components/box';
import Icon from 'carbon-react/lib/components/icon';
import Typography from 'carbon-react/lib/components/typography';

export interface WizardFinishedProps {
  text?: string;
}

export const WizardFinished = ({ text }: WizardFinishedProps) => {
  const intl = useIntl();

  const defaultText = intl.formatMessage({
    id: 'common.finished',
    defaultMessage: 'Finished'
  });

  return (
    <Box display="flex" flexDirection="column" height="100%" alignItems="center" justifyContent="center">
      <Box>
        <Typography variant="p" fontWeight="500" textAlign="center" mb={0}>
          <Icon
            type="tick_thick"
            bgSize="extra-large"
            bgShape="circle"
            bg="--colorsActionMajor500"
            color="--colorsUtilityYang100"
            fontSize="large"
            mb={2}
          />
        </Typography>
        <Typography variant="p" fontWeight="500" textAlign="center">
          {text ?? defaultText}
        </Typography>
      </Box>
    </Box>
  );
};
